import { transform } from "./affineTransformation";
import { CORNER_INDEXES, vertexOfOriginRect } from "./rect";

export const verticesOfElement = ({ frame, angle }) =>
  CORNER_INDEXES.map(index =>
    transform(
      vertexOfOriginRect(index, frame.width, frame.height),
      frame,
      angle
    )
  );
